// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trust-and-excellence-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.trust-and-excellence-section .trust-and-excellence-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.trust-and-excellence-section .trust-and-excellence-wrap .trust-and-excellence-box .para-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 400;
  line-height: 1.4;
}
.trust-and-excellence-section .trust-and-excellence-wrap .trust-and-excellence-box .trust-and-excellence-container {
  margin: 4rem 0;
}
.trust-and-excellence-section .trust-and-excellence-wrap .trust-and-excellence-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
.trust-and-excellence-section .trust-and-excellence-tabs-content-box {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 3.75rem;
}
.trust-and-excellence-section .trust-and-excellence-tabs-content-box .img-box {
  width: fit-content;
  height: 6.75rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.trust-and-excellence-section .trust-and-excellence-tabs-content-box .img-box img {
  width: auto;
  height: 100%;
}
.trust-and-excellence-section .embla .embla__viewport .embla__container .embla__slide {
  --embla-slide-number: 4;
  flex: 0 0 calc(100% / var(--embla-slide-number)) !important;
}
@media screen and (max-width: 991.98px) {
  .trust-and-excellence-section {
    padding: 2.5rem 0;
  }
  .trust-and-excellence-section .trust-and-excellence-wrap .trust-and-excellence-box .para-text {
    font-size: 1rem;
  }
  .trust-and-excellence-section .trust-and-excellence-wrap .trust-and-excellence-box .trust-and-excellence-container {
    margin: 2.5rem 0;
  }
  .trust-and-excellence-section .trust-and-excellence-wrap .trust-and-excellence-box .btn-box {
    margin-top: 2.5rem;
  }
  .trust-and-excellence-section .trust-and-excellence-tabs-content-box {
    gap: 2rem;
  }
  .trust-and-excellence-section .trust-and-excellence-tabs-content-box .img-box {
    height: 4.5rem;
  }
  .trust-and-excellence-section .embla .embla__viewport .embla__container .embla__slide {
    flex: 0 0 auto !important;
  }
}
@media screen and (max-width: 767.98px) {
  .trust-and-excellence-section {
    padding: 2rem 0;
  }
  .trust-and-excellence-section .trust-and-excellence-wrap .trust-and-excellence-box .para-text {
    font-size: 0.875rem;
  }
  .trust-and-excellence-section .trust-and-excellence-wrap .trust-and-excellence-box .trust-and-excellence-container {
    margin: 2rem 0;
  }
  .trust-and-excellence-section .trust-and-excellence-wrap .trust-and-excellence-box .btn-box {
    margin-top: 1.25rem;
  }
  .trust-and-excellence-section .trust-and-excellence-tabs-content-box {
    gap: 1.5rem;
  }
  .trust-and-excellence-section .trust-and-excellence-tabs-content-box .img-box {
    height: 3.5rem;
  }
}
@media screen and (max-width: 639.98px) {
  .trust-and-excellence-section {
    padding: 2rem 0;
  }
  .trust-and-excellence-section .trust-and-excellence-tabs-content-box {
    gap: 1rem;
  }
  .trust-and-excellence-section .trust-and-excellence-tabs-content-box .img-box {
    height: 2.5rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/TrustAndExcellenceSection/TrustAndExcellenceStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAAR;AAGM;EACE,cAAA;AADR;AAIM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AAFR;AAOE;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,YAAA;AALJ;AAOI;EACE,kBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALN;AAOM;EACE,WAAA;EACA,YAAA;AALR;AAaQ;EACE,uBAAA;EACA,2DAAA;AAXV;AAiBE;EA5DF;IA6DI,iBAAA;EAdF;EAkBM;IACE,eAAA;EAhBR;EAmBM;IACE,gBAAA;EAjBR;EAoBM;IACE,kBAAA;EAlBR;EAuBE;IACE,SAAA;EArBJ;EAuBI;IACE,cAAA;EArBN;EA4BQ;IACE,yBAAA;EA1BV;AACF;AAgCE;EAlGF;IAmGI,eAAA;EA7BF;EAiCM;IACE,mBAAA;EA/BR;EAkCM;IACE,cAAA;EAhCR;EAmCM;IACE,mBAAA;EAjCR;EAsCE;IACE,WAAA;EApCJ;EAsCI;IACE,cAAA;EApCN;AACF;AAwCE;EA9HF;IA+HI,eAAA;EArCF;EAuCE;IACE,SAAA;EArCJ;EAuCI;IACE,cAAA;EArCN;AACF","sourcesContent":[".trust-and-excellence-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .trust-and-excellence-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .trust-and-excellence-box {\n      .para-text {\n        color: var(--black-1000);\n        font-size: 1.5rem;\n        font-weight: 400;\n        line-height: 1.4;\n      }\n\n      .trust-and-excellence-container {\n        margin: 4rem 0;\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n    }\n  }\n\n  .trust-and-excellence-tabs-content-box {\n    display: flex;\n    justify-content: center;\n    flex-wrap: wrap;\n    gap: 3.75rem;\n\n    .img-box {\n      width: fit-content;\n      height: 6.75rem;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n\n      img {\n        width: auto;\n        height: 100%;\n      }\n    }\n  }\n\n  .embla {\n    .embla__viewport {\n      .embla__container {\n        .embla__slide {\n          --embla-slide-number: 4;\n          flex: 0 0 calc(100% / var(--embla-slide-number)) !important;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .trust-and-excellence-wrap {  \n      .trust-and-excellence-box {\n        .para-text {\n          font-size: 1rem;\n        }\n\n        .trust-and-excellence-container {\n          margin: 2.5rem 0;\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n    }\n\n    .trust-and-excellence-tabs-content-box {\n      gap: 2rem;\n  \n      .img-box {\n        height: 4.5rem;\n      }\n    }\n\n    .embla {\n      .embla__viewport {\n        .embla__container {\n          .embla__slide {\n            flex: 0 0 auto !important;\n          }\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .trust-and-excellence-wrap {  \n      .trust-and-excellence-box {\n        .para-text {\n          font-size: 0.875rem;\n        }\n\n        .trust-and-excellence-container {\n          margin: 2rem 0;\n        }\n  \n        .btn-box {\n          margin-top: 1.25rem;\n        }\n      }\n    }\n\n    .trust-and-excellence-tabs-content-box {\n      gap: 1.5rem;\n  \n      .img-box {\n        height: 3.5rem;\n      }\n    }\n  }\n  \n  @media screen and (max-width: 639.98px) {\n    padding: 2rem 0;\n\n    .trust-and-excellence-tabs-content-box {\n      gap: 1rem;\n  \n      .img-box {\n        height: 2.5rem;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
